import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { setLangauage, setLoginNew, setTab } from '../../store/LoginNew/loginNew.slice'


export const connectLanguagePopUp = (wrappedProps) => (component) => {
  function mapStateToProps(state) {
    return {
      elementsParams: state.elementsParams,
      language: state.loginNew.language,
    }
  }

  function mapDispatchToProps(dispatch) {
    const actions = {
      setTab,
      setLangauage
    }

    return { actions: bindActionCreators(actions, dispatch) }
  }

  return connect(mapStateToProps, mapDispatchToProps)(component)
}
